import { action, makeObservable, observable } from 'mobx';

import { IApiClient } from '../../../../app/data/client';
import Logger from '../../../../app/shared/Logger';
import { ModalState } from '../../../../app/shared/ModalState';
import { TermsModalTranslation } from '../../../localization/ModuleTranslation';
import type { BrandData, PricingContext, TermsAndConditionsParagraphData } from '../../../model';
import { GetTermsAndConditionsQuery } from '../../../queries';

export default class TermsModalState extends ModalState {
  @observable.ref
  public paragraphs: TermsAndConditionsParagraphData[] = [];

  @observable
  public isLoading = false;

  public constructor(
    private readonly client: IApiClient,
    private readonly pricingContext: PricingContext,
    public readonly translation: TermsModalTranslation,
    public readonly brand: BrandData,
  ) {
    super();

    makeObservable(this);
  }

  protected onBeforeOpen(): void {
    if (this.paragraphs.any()) {
      return;
    }

    this.load();
  }

  @action
  private async load(): Promise<void> {
    this.isLoading = true;

    try {
      const { documents } = await this.client.send(
        new GetTermsAndConditionsQuery({
          brandId: this.brand.id,
          pricingContext: this.pricingContext,
        }),
      );

      this.setParagraphs(documents.flatMap((document) => document.paragraphs));
    } catch (error) {
      Logger.error(`Unable to load document terms. Brand ID: ${this.brand.id}. Error: ${error}`);
    } finally {
      this.setIsLoading(false);
    }
  }

  @action
  private setParagraphs(paragraphs: TermsAndConditionsParagraphData[]): void {
    this.paragraphs = paragraphs;
  }

  @action
  private setIsLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }
}
